<template>
  <v-dialog
    :model-value="isVisible"
    fullscreen
    transition="dialog-bottom-transition"
    @update:model-value="$emit('update:isVisible', $event)"
  >
    <v-card class="image-fullscreen">
      <v-toolbar
        color="black"
        density="compact"
      >
        <v-toolbar-title>{{ $t('labels.image-preview') }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="image-fullscreen__content">
        <slot
          name="content"
          :image="image"
        >
          <img
            v-if="image"
            :src="image"
            class="image-fullscreen__image"
            alt="Fullscreen image"
          />
        </slot>
        <div
          v-if="isStockImage"
          data-product-fruits="content-creator-image-fullscreen-dialog"
          class="image-fullscreen__stock-marker"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
interface Props {
  isVisible: boolean
  image?: string
  isStockImage?: boolean
}

interface Emits {
  'update:isVisible': [value: boolean]
  close: []
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<style scoped>
.image-fullscreen {
  background: #000000;
}

.image-fullscreen__content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 64px);
  padding: 16px;
  position: relative;
}

.image-fullscreen__image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-fullscreen__stock-marker {
  position: absolute;
  bottom: 16px;
  left: 16px;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
</style>
